'use client';


import {styled} from "@mui/material/styles";
import {TreeItem} from "@mui/x-tree-view";
import CustomTreeItemProps from "@/src/_types/custom-tree-item-props";

const CustomTreeItem = styled(TreeItem, {
    shouldForwardProp: (prop) => prop !== "depth" && prop !== "selectedSlug",
})<CustomTreeItemProps>(({theme, depth, selectedSlug, itemId}) => ({
    position: "relative",
    paddingLeft: `${depth * 15}px`,
    borderLeft: depth > 0 ? "1px solid rgba(0, 0, 0, 0.05)" : "none",

    "& .MuiTreeItem-content": {
        padding: '0 1rem',
        cursor: "pointer",
        color: "#777",
        "&:hover": {
            backgroundColor: "rgba(0, 0, 0, 0.04)",
        },
        "& p": {
            fontSize: '.8rem',
            fontWeight: itemId === selectedSlug ? 600 : 400,
        }
    },

    "&[aria-selected='true']": {
        color: theme.palette.primary.main,
    },
}));

export default CustomTreeItem;
